import HubEpworthQuestionnairePage from './HubEpworthQuestionnairePage'

export default HubEpworthQuestionnairePage
